import { PHASE_PRODUCTION_BUILD } from 'next/constants'

import { config } from 'src/config'
import { fetchProductSlugs } from 'src/data/providers/fetchProductSlugs'
import { getLanguageFromLocale } from 'src/functions/i18n/localeFns'
import { getMetafield } from 'src/functions/util/getMetafield'
import { ProductDetailPage, getStaticProps } from 'src/pages/[lang]/p/[slug]'

import type { GetStaticPaths } from 'next'
import type { Locale } from 'src/enum/Locale'

const getStaticPaths: GetStaticPaths = async () => {
  const paths: string[] = []
  const langs = config.locales.map((locale) => getLanguageFromLocale(locale as Locale))

  await Promise.all(
    langs.map(async (lang) => {
      const productSlugs = (
        await fetchProductSlugs({
          lang: lang.toUpperCase(),
          first: 250,
          productType: 'coffee',
        })
      ).filter(({ metafields }) => !getMetafield(metafields, 'b2b', 'exclusive'))

      if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
        // eslint-disable-next-line no-console
        console.log(`\n☕️  will create ${productSlugs.length} pages for ${lang} coffee products`)
      }

      productSlugs.forEach(({ handle }) => {
        paths.push(`/${lang}/k/${handle}`)
      })
    }),
  )

  return {
    paths,
    fallback: false,
  }
}

export { getStaticPaths, getStaticProps }

export default ProductDetailPage
